import { useGetSettingQuery } from '../../../../Redux/Apis/siteApi'

function Team() {
    const {data :{home: {team : {data,name}}}} = useGetSettingQuery()

    return ( 
        <div className="container-xxl py-5" id='team'>
            <div className="container">
                <div className="section-title text-center">
                    <h1 className="display-5 mb-5">{name}</h1>
                </div>
                <div className="row g-4">
                    {data.lso_team && data.lso_team.map((row,index) => 
                    <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s" key={index}>
                        <div className="team-item">
                            <div className="overflow-hidden position-relative">
                                <img className="img-fluid" src={row.img_profile} alt=""/>
                                <div className="team-social">
                                    <a className="btn btn-square" href={row.txt_facebook}><i className="fab fa-facebook-f"></i></a>
                                    <a className="btn btn-square" href={row.txt_twitter}><i className="fab fa-twitter"></i></a>
                                    <a className="btn btn-square" href={row.txt_linkedin}><i className="fab fa-linkedin"></i></a>
                                </div>
                            </div>
                            <div className="text-center border border-5 border-light border-top-0 p-4">
                                <h5 className="mb-0">{row.txt_name}</h5>
                                <small>{row.txt_career}</small>
                            </div>
                        </div>
                    </div>)}
                </div>
            </div>
        </div>
     );
}

export default Team;